import { Menu, MenuItem } from "@mui/material";
import EditCategory from "./EditCategory";
import ValidateAccess from "components/ValidateAccess";
import { Permissions } from "data/permissons";
import { AccountMenuProps } from "layout/primarylayout/AccountMenu";
import { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { useConfirm } from "context/ConfirmDialog";
import { deleteClientSubCategory } from "api/services/client-categories";

interface EditCategoryPopoverProps extends AccountMenuProps {
  data: any;
  selectedSubCategory: any;
}

function EditSubCategoryPopover(props: EditCategoryPopoverProps) {
  const { anchorEl, setAnchorEl, data, selectedSubCategory } = props;
  const [editCategoryOpen, setEditCategoryOpen] = useState<boolean>(false);
  const open = Boolean(anchorEl);
  const queryClient = useQueryClient();
  const confirm = useConfirm();

  const handleEdit = () => {
    setEditCategoryOpen(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { mutate: deleteMutate } = useMutation(deleteClientSubCategory, {
    onSuccess: () => {
      snack.success("Sub Category Deleted");
      queryClient.invalidateQueries("client-categories");
      setAnchorEl(null);
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const handleDelete = () => {
    confirm({
      msg: "Are you sure you want to delete this Sub Category?",
      action: () => deleteMutate({ id: selectedSubCategory?.id }),
    });
  };

  return (
    <>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { minWidth: 100 },
        }}
      >
        <ValidateAccess name={Permissions.EDIT_CLIENT_CATEGORIES}>
          <MenuItem onClick={handleEdit}>Edit</MenuItem>
        </ValidateAccess>
        <ValidateAccess name={Permissions.DELETE_CLIENT_CATEGORIES}>
          <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </ValidateAccess>
      </Menu>

      <EditCategory open={editCategoryOpen} setOpen={setEditCategoryOpen} data={data} />
    </>
  );
}

export default EditSubCategoryPopover;
